import React from 'react';
import { useMessageConfig } from 'hooks/useMessageConfig';

interface MessageConfigProviderProps {
  children: React.ReactNode;
}

export const MessageConfigProvider: React.FC<MessageConfigProviderProps> = ({
  children,
}) => {
  useMessageConfig();

  return <>{children}</>;
};
